const Myprojects = [
  {
    name: "Rad u rudniku",
    isLarge: true,
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  },
  {
    name: "Rad u rudniku 2",
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
  },
  {
    name: "Rad u rudniku 3",
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. Opis 3",
  },
  {
    name: "Rad u rudniku 4",
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. Opis 4",
  },
  {
    name: "Rad u rudniku 5",
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. Opis das.",
  },
  {
    name: "Rad u rudniku 6",
    isLarge: true,
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. Opis nestoo",
  },
  {
    name: "Rad u rudniku 7",
    isLarge: true,
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. Opis 3dsasasad",
  },
  {
    name: "Rad u rudniku 8",
    img: "./portfolio/p1/img.webp",
    hover: "./portfolio/p1/hover.gif",
    video: "./portfolio/p1/video.mp4",
    desc: "Lorem Ipsum is simply dummy text of the. dsa dsad dsa",
  },
];
export default Myprojects;
